import React from 'react';
import { Typography } from '@mui/material';

interface LookupAmountTemplateProps {
  amount?: number;
}

/**
 * Currency amount display for lookup grid.
 */
export const LookupAmountTemplate: React.FC<LookupAmountTemplateProps> = ({ amount }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace', textAlign: 'right' }}>
    ${amount?.toFixed(2) || '0.00'}
  </Typography>
);

/** Syncfusion grid template wrapper */
export const lookupAmountTemplate = (props: { amount?: number }) => (
  <LookupAmountTemplate amount={props.amount} />
);

export default LookupAmountTemplate;
